import React from 'react';
import { Link } from 'react-router-dom';
import useAuth from '../Authentication/components/hooks/useAuth';

export default function ExperienceEditorLink({
    activationId,
    galleryId,
}: {
    activationId?: number | string;
    galleryId?: number | string;
}) {
    const { auth } = useAuth();
    if (
        !activationId ||
        !galleryId ||
        !auth?.roles?.some((role: number) => role === 0 || role === 69)
    )
        return null;
    return (
        <div className="my-4 rounded-lg border border-gray-200 bg-white p-4 text-gray-900">
            <div className="flex flex-wrap items-center justify-between gap-3">
                <div>
                    <strong>Custom gallery experience</strong>
                    <p className="mt-1 text-sm text-gray-500">
                        Design all three guest views and choose which gallery
                        experience this activation uses.
                    </p>
                </div>
                <Link
                    to={`/gallery-experiences/${activationId}/${galleryId}`}
                    className="rounded-md bg-black px-4 py-2 text-sm font-semibold text-white"
                >
                    Open designer
                </Link>
            </div>
        </div>
    );
}
